var _rect, _polygon, _circle, _circle2, _circle3, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 58",
    width: 290,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 36,
    rx: 10,
    fill: "#065183"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11,37 4,52 26,37",
    fill: "#065183"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 19,
    r: 3.8,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 19,
    r: 3.8,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 19,
    r: 3.8,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 21,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 300,
    fill: "#065183",
    letterSpacing: 2.5
  }, "Quero")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 44,
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#065183",
    letterSpacing: 0.5
  }, "Atendimento")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d3fb138fea195d89708cfda75d890e3.svg";
export { ForwardRef as ReactComponent };